$(function(){
    var form = $(".register form");
    $(form).submit(function(event){
        event.preventDefault();
        var formMessages = $(this).parents('.register').find('.form-messages');
        $(formMessages).removeClass('hide');
        var spinner = $(this).parents('.register').find(".spinner");
        var formData = $(this).serialize();
        $(spinner).fadeIn('fast');

        $.ajax({
            type: 'POST',
            url: $(form).attr('action'),
            data: formData
        }).done(function(response) {
            $(spinner).fadeOut('fast');

            if(response.status == 'error') {
                $(formMessages).removeClass('success');
                $(formMessages).addClass('error');
            } else {
                $(formMessages).removeClass('error');
                $(formMessages).addClass('success');
            }
            // Set the message text.
            if(response.message == undefined) {
                $(formMessages).html("Thank You! We will contact you soon.");
                $("input[type=text]").val('');
                $("input[type=email]").val('');

                setTimeout(function(){
                  $(formMessages).addClass('hide');
                }, 5000);
            }
            else {
                $(formMessages).html(response.message);
            }
        }).fail(function(data) {
            $(spinner).fadeOut('fast');
            // Make sure that the formMessages div has the 'error' class.
            $(formMessages).removeClass('success');
            $(formMessages).addClass('error');

            // Set the message text.
            if (data.responseText !== '') {
                $(formMessages).text(data.responseText);
            } else {
                $(formMessages).text('Oops! An error occured and your message could not be sent.');
            }
        });
    });
});